(function () {
  const CM_PER_INCH = 2.54;

  function formatCm(value) {
    return String(Math.round(Number(value)));
  }

  function formatInches(value) {
    const inches = Number(value) / CM_PER_INCH;
    const rounded = Math.round(inches * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  }

  function formatMeasurement(cell, unit) {
    const formatter = unit === 'in' ? formatInches : formatCm;
    const min = cell.dataset.cmMin;
    const max = cell.dataset.cmMax;
    const value = cell.dataset.cmValue;

    if (min != null && max != null) {
      return `${formatter(min)} \u2013 ${formatter(max)}`;
    }

    if (value != null) {
      return formatter(value);
    }

    return '';
  }

  function setUnit(modal, unit) {
    modal.dataset.unit = unit;

    modal.querySelectorAll('.size-guide-modal__units-btn').forEach((button) => {
      const isActive = button.dataset.unit === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    modal.querySelectorAll('.size-guide-modal__measurement').forEach((cell) => {
      const output = cell.querySelector('.size-guide-modal__measurement-value');
      if (!output) return;
      output.textContent = formatMeasurement(cell, unit);
    });
  }

  function initSizeGuide(root) {
    if (root.dataset.sizeGuideInit === 'true') return;
    root.dataset.sizeGuideInit = 'true';

    const toggle = root.querySelector('.size-guide-modal__units-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', (event) => {
      const button = event.target.closest('.size-guide-modal__units-btn');
      if (!button || button.classList.contains('is-active')) return;
      setUnit(root, button.dataset.unit);
    });

    if (root.tagName === 'MODAL-DIALOG') {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open' && root.hasAttribute('open')) {
            setUnit(root, 'cm');
          }
        });
      });

      observer.observe(root, { attributes: true, attributeFilter: ['open'] });
    }

    setUnit(root, root.dataset.unit || 'cm');
  }

  function initSizeGuideRoots() {
    document
      .querySelectorAll('modal-dialog.size-guide-modal:not(.size-calculator-modal), [data-size-guide]')
      .forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideRoots);
  } else {
    initSizeGuideRoots();
  }

  document.addEventListener('shopify:section:load', initSizeGuideRoots);
})();
